export default __webpack_public_path__ + "static/media/arantxa-aguilar-fibromialgia-en-positivo.b0be3819.jpg";